
<div id="pageloader" #divPageLoad *ngIf="this.isloaded===true">
    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
<div class="bg-holder full-wh z1">
            
               
  <!-- <b data-bgholder="overlay" class="full-wh z2" data-rgradient="y" data-rg-colors="rgba(0, 0, 0, 0.2)|rgba(0, 0, 0, 0.4)"></b> -->
   
  <div data-bgholder="slider" class="full-wh z1 h100" data-ckav-sm="h100" data-bgslider="./assets/images/Background homepage.png">
    <div class="bgslider full-wh"></div>
  </div>

</div>
 <!--
            ************************************************************
            * SCROLLING SECTIONS
            *************************************************************
            -->
            <div class="scrollwrapper swiper-container" data-mytooltip="Index,Brand,About,Portfolio,Regis">
              <div class="scrollinner swiper-wrapper">
                    
                  <!--
                  ************************************************************
                  * HOME SECTION 01
                  *************************************************************
                  -->
                  <!-- <section id="homesection" class="page-section swiper-slide typo-light align-c" data-hash="home">
                      <div class="min-vh-h100 w100 flex-cc pd-tb-100" data-ckav-sm="pd-tb-large">
                          <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                              <div class="container">
                                  <div class="w90 mr-auto" data-ckav-sm="w100">
    
                                      <div class="carousel-widget ctrl-3 align-c animated" data-animIn="fadeInUp"
                                          data-items="1"
                                          data-nav="false"
                                          data-pager="false"
                                          data-itemrange="0,1|420,1|600,1|768,1|992,1|1200,1"
                                          data-margin="30"
                                          data-autoplay="true"
                                          data-hauto="true"
                                          data-in="fadeIn"
                                          data-out="fadeOut"
                                          data-loop="true"
                                          data-center="false">
                                          <div class="owl-carousel">
                                              
                                              <div class="item">
                                                  <h2 class="title fs80 lh-1 f-1 mr-b-30" data-ckav-sm="fs40" data-animIn="fadeInUp">It’s not about ideas. <br>It’s about making ideas happen</h2>
                                              </div>
                                              <div class="item">
                                                  <h2 class="title fs80 lh-1 f-1 mr-b-30" data-ckav-sm="fs40" data-animIn="fadeInUp">You have to believe it. <br>before you see it</h2>
                                              </div>
                                              <div class="item">
                                                  <h2 class="title fs80 lh-1 f-1 mr-b-30" data-ckav-sm="fs40" data-animIn="fadeInUp">A satisfied customer is the<br>best business strategy of all</h2>
                                              </div>
                                      
                                          </div>
                                      </div>
                                      <p class="fs18 f-2 lh-6 mr-b-40 w80 mr-auto animated" data-ckav-sm="fs16 mr-b-30 w100" data-animIn="fadeInUp|0.1">
                                          <span class="op-08">
                                              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maxime adipisci doloremque, eum architecto odit, veniam temporibus ipsam esse natus sed nam cum officia ex. Enim non eum qui sed praesentium? sit amet consectetur adipisicing elit. Maxime adipisci doloremque, eum architecto odit, veniam temporibus ipsam esse natus sed nam cum officia ex.
                                          </span>
                                      </p>
                                      <a href="#" class="btn btn-default large solid fs16 f-1 txt-upper hov-btn-secondary round animated" data-ckav-sm="medium" data-animIn="fadeInUp|0.2">Learn More</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section> -->
                  <!-- ************** END : HOME SECTION 01 **************  -->
                  
                  <!--
                  ************************************************************
                  * ABOUT SECTION 01
                  *************************************************************
                  -->
    
                  <!--   data-rgradient="y" data-rg-colors="rgba(229, 221, 211, 1)|rgba(229, 203, 166, 1)" -->
                  <section id="aboutsection" class="page-section swiper-slide typo-light" data-hash="index">
                      <div class="min-vh-h100 w100 flex-cc pd-t-100" data-ckav-sm="pd-tb-large" 
                     
                     
                      >
                      <!-- style=" background: linear-gradient(0deg, rgba(229, 203, 166, 1) 40%, rgba(229, 221, 211, 1) 60%);" -->
                          <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                              <div class="container" data-ckav-sm="align-c">
                                  <div class="row align-items-center w120">
                                    <!-- col-lg-7 offset-lg-1 order-lg-last animated -->
                                      <div class="col-lg-7 order-lg-last animated" data-ckav-sm="mr-b-40" data-animIn="fadeInRight">
                                          <img class="px-h750" data-ckav-sm="h-reset" src="./assets/images/banner.png" alt="about image">
                                      </div>
                                      <div class="col-lg-5 animated" style="text-align: center;" data-animIn="fadeInLeft">
                                          <h4 class="title fs40 lh-1 f-1 mr-b-30" data-ckav-sm="fs30" style="color:black;">NÂNG TẦM ĐẲNG CẤP</h4>
                                          <p class="fs22 f-2 lh-6 mr-b-40" data-ckav-sm="fs16 mr-b-30">
                                              <span class="op-08" style="color:black;">
                                                Khi trở thành Nhà phân phối thương hiệu mỹ phẩm Hàn quốc cao cấp đến từ Tập đoàn LG cosmetics
                                              </span>
                                          </p>
                                          <div class="footerBanner">
                                            <a href="#portfolio" class="btn btn-default solid fs16 f-1 txt-upper mr-r-20 round">TÌM HIỂU THÊM</a>
    
                                            <img   id="sec1ImgAllLogo" src="./assets/images/LOGO 7 BRAND.png" alt="logo">
                                          </div>
                                      
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
                  <!-- ************** END : ABOUT SECTION 01 **************  -->
                 <section id="socialsection" class="page-section swiper-slide typo-light" data-hash="brand">
                      <div class="min-vh-h100 w100 flex-cc pd-tb-100" data-ckav-sm="pd-tb-large" 
                      >
                          <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                              <div class="container">
                                <h2 style="color: black; width: 100%; text-align: center; margin-bottom: 30px; margin-top: 30px;     font-weight: 300;">THƯƠNG HIỆU CỦA CHÚNG TÔI</h2>
                                <div class="row" style="text-align: center;display: flex; justify-content: center;">
                                    <div class="col-md-3 mr-t-20">
                                        <a  href="https://whoo.com.vn/" target="_blank" class=" px-w160 fs40 mt-10 rd-4 iconbox btn-white animated" data-animin="fadeInUp|0.5">
                                        
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/1.png" alt=""/>
                                        </a>
                                    </div>  
                                    <div class="col-md-3 mr-t-20">
                                        <a href="https://ohui.vn/" target="_blank" class="px-w160 fs40 mt-10 rd-4 iconbox btn-white animated" data-animin="fadeInUp|1">
                                        
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/2.png" alt=""/>
                                        </a>
                                    </div>  
                                    <div class="col-md-3 mr-t-20">
                                        <a href="https://www.facebook.com/sum37.com.vn" target="_blank" class="px-w160 fs40 mt-10 rd-4 iconbox btn-white animated" data-animin="fadeInUp|1.5">
                                            
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/3.png" alt=""/>
                                        </a>
                                    </div>  
                                    <div class="col-md-3 mr-t-20">
                                        <a href="#" target="_blank" class="px-w160 fs40 mt-10 rd-4 iconbox btn-white animated" data-animin="fadeInUp|1.8">
                                            
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/4.png" alt=""/>
                                        </a>
                                    </div>  
                                    <div class="col-md-3 mr-t-20">
                                        <a href="https://www.facebook.com/CNPLABORATORY" target="_blank" class="px-w160 fs40 mt-10 rd-4 iconbox btn-white animated" data-animin="fadeInUp|2">
                                            
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/5.png" alt=""/>
                                        </a>
                                    </div>  
                                    <div class="col-md-3 mr-t-20">
                                        <a href="https://www.facebook.com/belifcosmeticvietnam" target="_blank" class="px-w160 fs40 mt-10 rd-4 iconbox btn-white animated" data-animin="fadeInUp|2.1">
                                            
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/6.png" alt=""/>
                                        </a>
                                    </div>  
                                    <div class="col-md-3 mr-t-20">
                                        <a href="https://www.facebook.com/beyondvn.official/" target="_blank" class="px-w160 fs40 mt-10  rd-4 iconbox btn-white animated" data-animin="fadeInUp|2.5">
                                            
                                            <img style="    width: 130%; max-width: unset;" src="./assets/images/HINH 7 BRAND-TRANS/7.png" alt=""/>
                                        </a>
                                    </div>  
                                    
                                       
                                    
                                       
                                    
                                       
                                    
                                
                                
                            </div>
          
                              </div>
                          </div>
                      </div>
                  </section>
                  <!--
                  ************************************************************
                  * TEAM SECTION 01
                  *************************************************************
                  -->
    <!-- 
                  data-rgradient="y" 
                    data-rg-colors="rgba(0, 0, 0, 0.5)|rgba(0, 0, 0, 1)"
                    style=" background: linear-gradient(0deg, rgba(229, 221, 211, 1) 50%, rgba(229, 203, 166, 1) 50%);" -->
                  <section id="teamsection" class="page-section swiper-slide typo-light align-c" data-hash="about" style="    background-color: rgb(255, 255, 255);">
                    <div class="min-vh-h100 w100 flex-cc pd-t-100" data-ckav-sm="pd-tb-large" 
                    
                    >
                    <!-- pd-tb-100 -->
                      <div class="innerwrapper w100 animated"  data-animOut="fadeOut" >
                          <div class="container">
                            <!-- align-items-center  -->
                              <div class="row "  >
                                  <div class="col-lg-3 animated" data-animIn="fadeInDown" data-ckav-sm="mr-b-40">
    
    <!--                                                                 
                                    
    <div class="swiper sample-slider">
        <div class="swiper-wrapper">
            <div class="swiper-slide"><img src="./assets/images/AG LP/BIN_2306.jpg"></div>
            <div class="swiper-slide"><img src="./assets/images/AG LP/BIN_2306.jpg"></div>
            <div class="swiper-slide"><img src="./assets/images/AG LP/BIN_2306.jpg"></div>
            <div class="swiper-slide"><img src="./assets/images/AG LP/BIN_2306.jpg"></div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div> -->
    
                                    <a type="button" class="clickNext "  style="text-align: center;
                                    width: 40%;
                                    margin-top: 20px;
                                    height: 50px;" >
                                        <!-- background-color: coral; -->
                                        <img src="./assets/images/downArrow.png" class="animated fadeInDown infinite" alt="" style="    width: 40%;
                                        margin: auto;
                                        color: brown;"/>
    
                                    </a>
                                   
                                    <!-- <section class="slider  ">
                                      <div class="slider__flex">
                                        <div class="slider__col">
                                     
                                    
                                          <div class="slider__thumbs">
                                            <div class="swiper-container"> 
                                              <div class="swiper-wrapper">
                                                <div class="swiper-slide">
                                                  
                                                </div>
                                                <div class="swiper-slide">
                                                  <div class="slider__image"><img src="./assets/images/AG LP/BIN_2306.jpg" alt=""/></div>
                                                </div>
                                                <div class="swiper-slide">
                                                  <div class="slider__image"><img src="./assets/images/AG LP/BIN_3940.jpg" alt=""/></div>
                                                </div>
                                                <div class="swiper-slide">
                                                  <div class="slider__image"><img src="./assets/images/AG LP/DSC00929.jpg" alt=""/></div>
                                                </div>
                                                <div class="swiper-slide">
                                                  <div class="slider__image"><img src="./assets/images/AG LP/DSC02355.jpg" alt=""/></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                    
                                       
                                    
                                        </div>
                                     
                                      </div>
                                    </section> -->
                                    <div class="slickSlide ">  
                                        <div class="slider__image">
                                            <a class="test-popup-link" href="./assets/images/slide2/1.png">
                                                <img  src="./assets/images/slide2/1.png" alt=""/>
                                            </a>
                                          </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/2.png">
                                            <img  src="./assets/images/slide2/2.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/3.png">
                                            <img  src="./assets/images/slide2/3.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/4.png">
                                            <img  src="./assets/images/slide2/4.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/5.png">
                                            <img  src="./assets/images/slide2/5.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/6.png">
                                            <img  src="./assets/images/slide2/6.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/7.png">
                                            <img  src="./assets/images/slide2/7.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/8.png">
                                            <img  src="./assets/images/slide2/8.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/8.png">
                                            <img  src="./assets/images/slide2/8.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/9.png">
                                            <img  src="./assets/images/slide2/9.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/10.png">
                                            <img  src="./assets/images/slide2/10.png" alt=""/>
                                        </a>
                                      </div>
                                      <div class="slider__image">
                                        <a class="test-popup-link" href="./assets/images/slide2/11.png">
                                            <img  src="./assets/images/slide2/11.png" alt=""/>
                                        </a>
                                      </div>
                                       
                                        
                                   </div>
                                  </div>
                                 
                                  <div class="col-lg-8 offset-lg-1 animated" data-animIn="fadeInRight" style="text-align: center; background-color: white;" >
                                       <!-- <h2>KHÁM PHÁ</h2>
                                       <h4>Những điều <span style="color:#C00C3F ;">tuyệt vời</span> cùng chúng tôi</h4> -->
                                       <div class="row mr-t-30"  id="videoContent" >
                                            <a href="#"  class="viewbtn">
                                                <img  src="./assets/images/new- play video.png" alt=""/>
                                            </a>
                                        </div>
                                        <a href="#" class="btn btn-default solid fs16 f-1 txt-upper mr-r-20 round viewbtn" id="" style="margin-top: 20px;">
                                            Bộ sưu tập
                                        </a>
    
                                        <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/Wcm_6RKAWMk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                                        <a href="#regis" class="btn btn-default solid fs16 f-1 txt-upper mr-r-20 round" style="margin-top: 20px;">Đăng ký để trở thành Nhà Phân Phối</a>
                                  </div>
                              </div>
      
                          </div>
                      </div>
                  </div>
                  </section>
                  <!-- ************** END : TEAM SECTION 01 **************  -->
    
                  <!--
                  ************************************************************
                  * PORTFOLIO SECTION 01
                  *************************************************************
                  -->
                  <section id="portfoliosection" class="page-section swiper-slide typo-light" data-hash="portfolio" data-stheme="sdark" data-secname="Portfolio">
                    <div class="min-vh-h100 w100 flex-cc pd-t-100 bg-dark" data-ckav-sm="pd-tb-large">
                        <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                            <div class="container-fluid w60" data-ckav-sm="align-c w100">
                                <div class="row">
                                   
                                    <div class="col-md-12 ">
                                        <div class="swiper-gallery layout-3 animated" data-animIn="fadeIn" data-autoplay="false">
    
                                            <!-- LARGE IMAGE -->
                                            <div class="swiper-container gallery-top">
                                                <div class="swiper-wrapper vh50">
                                
                                                      <!-- SLIDE -->
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/1.png"></div>
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/2.png"></div>
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/3.png"></div>
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/4.png"></div>
    <!--                                                  
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/5.png"></div>
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/5.png"></div>
                                                      <div class="swiper-slide" data-bg="./assets/images/slide3XX/5.png"></div> -->
            
                                                   <!-- SLIDE -->
                                                    <!-- -->
                                                    <!-- <div class="swiper-slide"   >
                                                      <div class="row">
                                                        <div class="col-md-4" id="bgSlide1">
                                                            <img  src="./assets/images/slide3/1.png" alt=""/>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <img  src="./assets/images/slide3/2.png" alt=""/> 
                                                        </div>
                                                      </div>
            
            
                                                  </div>
                                                  <div class="swiper-slide"   >
                                                    <div class="row">
                                                      <div class="col-md-6" id="bgSlide1">
                                                          <img  src="./assets/images/slide3/3.png" alt=""/>
                                                      </div>
                                                      <div class="col-md-6">
                                                          <img  src="./assets/images/slide3/4.png" alt=""/> 
                                                      </div>
                                                    </div>
            
            
                                                </div>
                                                <div class="swiper-slide"   >
                                                    <div class="row">
                                                      <div class="col-md-6" id="bgSlide1">
                                                          <img  src="./assets/images/slide3/5.png" alt=""/>
                                                      </div>
                                                      <div class="col-md-6">
                                                          <img  src="./assets/images/slide3/6.png" alt=""/> 
                                                      </div>
                                                    </div>
            
            
                                                </div>
                                                <div class="swiper-slide"   >
                                                    <div class="row">
                                                      <div class="col-md-6" id="bgSlide1">
                                                          <img  src="./assets/images/slide3/7.png" alt=""/>
                                                      </div>
                                                      <div class="col-md-6">
                                                          <img  src="./assets/images/slide3/8.png" alt=""/> 
                                                      </div>
                                                    </div>
            
            
                                                </div> -->
                                                  <!-- <div class="swiper-slide" data-bg="./assets/images/Khi tro thanh NPP - slide 3/1.jpg"  > </div> -->
                                                   
                                             
                                
                                                </div>
                                
                                                <!-- NAVIGATION -->
                                                
                                            </div><!-- / LARGE IMAGE -->
                                            <div class="swiper-button-prev" id="leftbtnCustom"><i class="fa fa-angle-left"></i></div>
                                            <div class="swiper-button-next" id="rightbtnCustom"><i class="fa fa-angle-right"></i></div>
                            
                                            <!-- THUMB IMAGE -->
                                            <div class="swiper-container gallery-thumbs" style="display: none;" data-bgcolor="rgba(0,0,0,0.2)">
                                                <div class="swiper-wrapper">
                                    
    <!--                                              
                                                    <div class="swiper-slide" style="margin-right: 10px;
                                                    background-image: url('./assets/images/HINH 7 BRAND-TRANS/1.png');" 
                                                    data-bg="./assets/images/HINH 7 BRAND-TRANS/1.png"></div>
                                                    
                                                     <div class="swiper-slide" style="margin-right: 10px;
                                                     background-image: url('./assets/images/HINH 7 BRAND-TRANS/2.png');" 
                                                     data-bg="./assets/images/HINH 7 BRAND-TRANS/2.png"></div>
                                                       
                                                    <div class="swiper-slide" style="margin-right: 10px;
                                                    background-image: url('./assets/images/HINH 7 BRAND-TRANS/3.png');" 
                                                    data-bg="./assets/images/HINH 7 BRAND-TRANS/3.png"></div>
                                                      
                                                       <div class="swiper-slide" style="margin-right: 10px;
                                                       background-image: url('./assets/images/HINH 7 BRAND-TRANS/4.png');" 
                                                       data-bg="./assets/images/HINH 7 BRAND-TRANS/4.png"></div>
                                                        
                                                    <div class="swiper-slide" style="margin-right: 10px;
                                                    background-image: url('./assets/images/HINH 7 BRAND-TRANS/5.png');" 
                                                    data-bg="./assets/images/HINH 7 BRAND-TRANS/5.png"></div>
                                                      
                                                       <div class="swiper-slide" style="margin-right: 10px;
                                                       background-image: url('./assets/images/HINH 7 BRAND-TRANS/6.png');" 
                                                       data-bg="./assets/images/HINH 7 BRAND-TRANS/6.png"></div>
                                                       
                                                    <div class="swiper-slide" style="margin-right: 10px;
                                                    background-image: url('./assets/images/HINH 7 BRAND-TRANS/7.png');" 
                                                    data-bg="./assets/images/HINH 7 BRAND-TRANS/7.png"></div>
                                     -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="col-md-12 mr-t-30" style="text-align: center;">
                                        
                                        <a  href="#" target="_blank" class=" px-w200 fs40 mt-10 mr-5 rd-4 iconbox btn-white animated" data-animin="fadeInUp|0.5">
                                            
                                            <img src="./assets/images/slide4/1.png" alt=""/>
                                        </a>
                                        <a href="#" target="_blank" class="px-w200 fs40 mt-10 mr-5 rd-4 iconbox btn-white animated" data-animin="fadeInUp|1">
                                            
                                            <img src="./assets/images/slide4/2.png" alt=""/>
                                            </a>
                                            <a href="#" target="_blank" class="px-w200 fs40 mt-10 mr-5 rd-4 iconbox btn-white animated" data-animin="fadeInUp|1.5">
                                                
                                                <img src="./assets/images/slide4/3.png" alt=""/>
                                            </a>
                                        
                                    
                                </div>
                                </div>
                                
    
                            </div>
                        </div>
                    </div>
                </section>
                  <!-- <section id="portfoliosection" class="page-section swiper-slide typo-light" data-hash="portfolio">
                      <div class="min-vh-h100 w100 flex-cc pd-tb-100" data-ckav-sm="pd-tb-large" data-rgradient="y" data-rg-colors="rgba(0, 0, 0, 0.5)|rgba(0, 0, 0, 1)">
                          <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                              <div class="container-fluid w80" data-ckav-sm="align-c">
                                  <div class="carousel-widget fill-dot ctrl-3 ctrl-light align-c overflow-none" 
                                      data-items="1"
                                      data-nav="false"
                                      data-pager="true"
                                      data-itemrange="0,1|420,1|600,1|768,3|992,3|1200,4"
                                      data-margin="30"
                                      data-autoplay="false"
                                      data-hauto="false"
                                      data-in="false"
                                      data-out="false"
                                      data-center="false">
                                      <div class="owl-carousel">
                                          
                                          <div class="item animated" data-animIn="fadeIn|0.1">
                                              <img src="./assets/template/images/portfolio-600x1000-01.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.2">
                                              <img src="./assets/template/images/portfolio-600x1000-02.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.3">
                                              <img src="./assets/template/images/portfolio-600x1000-03.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.4">
                                              <img src="./assets/template/images/portfolio-600x1000-04.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.1">
                                              <img src="./assets/template/images/portfolio-600x1000-05.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.2">
                                              <img src="./assets/template/images/portfolio-600x1000-06.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.3">
                                              <img src="./assets/template/images/portfolio-600x1000-07.jpg" class="rd-5" alt="image">
                                          </div>
    
                                          <div class="item animated" data-animIn="fadeIn|0.4">
                                              <img src="./assets/template/images/portfolio-600x1000-08.jpg" class="rd-5" alt="image">
                                          </div>
      
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section> -->
                  <!-- ************** END : PORTFOLIOs SECTION 01 **************  -->
    
                  <!--
                  ************************************************************
                  * CONTACT SECTION 01
                  *************************************************************
                  -->
                  <!-- data-rgradient="y" data-rg-colors="rgba(0, 0, 0, 0.5)|rgba(0, 0, 0, 1)" -->
                  <section id="contactsection" class="page-section swiper-slide typo-light" data-hash="regis" style="    background-color: #EFEBEE;">
                      <div class="min-vh-h100 w100 flex-cc pd-t-100" data-ckav-sm="pd-tb-large"
                      >
                          <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                              <div class="container">
                                  
                                  <div class="row align-items-center">
                                      <!-- <div class="col-lg-5 offset-lg-1 order-lg-last" data-ckav-sm="mr-b-40">
                                          <div class="info-obj img-l g30 mini animated" data-animIn="fadeInUp">
                                              <div class="img txt-default"><span class="iconwrp"><i class="pe-7s-map-marker"></i></span></div>
                                              <div class="info align-l">
                                                  <h3 class="title mini bold-4 mr-b-10 f-1" data-ckav-sm="fs16">Our Location</h3>
                                                  <p class="mr-0 f-1 op-07">
                                                      PO Box 16122, Collins Street West, Victoria 8007, Australia
                                                  </p>
                                              </div>
                                          </div>
                  
                                          <hr class="bdr-op-light-1 mr-tb-40 animated" data-ckav-sm="mr-tb-30" data-animIn="fadeInUp|0.1">
                  
                                          <div class="info-obj img-l g30 mini animated" data-animIn="fadeInUp|0.2">
                                              <div class="img txt-default"><span class="iconwrp"><i class="pe-7s-call"></i></span></div>
                                              <div class="info align-l">
                                                  <h3 class="title mini bold-4 mr-b-10 f-1" data-ckav-sm="fs16">Call Us</h3>
                                                  <p class="mr-0 f-1 op-07">
                                                      +1234-678-890
                                                  </p>
                                              </div>
                                          </div>
                  
                                          <hr class="bdr-op-light-1 mr-tb-40 animated" data-ckav-sm="mr-tb-30" data-animIn="fadeInUp|0.3">
                  
                                          <div class="info-obj img-l g30 mini animated" data-animIn="fadeInUp|0.4">
                                              <div class="img txt-default"><span class="iconwrp"><i class="pe-7s-mail-open"></i></span></div>
                                              <div class="info align-l">
                                                  <h3 class="title mini bold-4 mr-b-10 f-1" data-ckav-sm="fs16">E-Mail Us</h3>
                                                  <p class="mr-0 f-1 op-07">
                                                      c.kav.art@gmail.com
                                                  </p>
                                              </div>
                                          </div>
                                      </div> -->
                                      <div class="col-lg-12 animated" data-animIn="fadeInLeft">
                                          <h3 class="title fs60 lh-1 f-1 mr-b-40" data-ckav-sm="fs30 mr-b-30" style="    font-size: 32px;
                                          text-align: center;
                                          color: #9B6164;">ĐĂNG KÍ TRỞ THÀNH NHÀ PHÂN PHỐI</h3>
                                            <!-- <h2 style="text-align: center; margin-bottom: 30px;"> ĐIỂM NỔI BẬT</h2> -->
                                           
                                          <form  class="form-widget align-l" novalidate="novalidate" data-ckav-sm="w100">
                                              <div class="field-wrp mr-b-40">
                                                  <!-- <input type="hidden" name="to" value="c.kav.art@gmail.com"> -->
                      
                                                  <div class="row gt10">
                                                      <div class="col-md-6">
                                                          <div class="form-group">
                                                              <input #txtName class="form-control form-control-light bb" data-label="Name" required="" data-msg="Vui lòng nhập Họ tên" type="text" name="name" placeholder="* Họ tên" aria-required="true">
                                                          </div>
                                                      </div>
                                                      <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input #txtCompany class="form-control form-control-light bb" data-label="Company" required="" data-msg="Vui lòng nhập Tên doanh nghiệp." type="text" name="Company" placeholder="* Tên doanh nghiệp" aria-required="true">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input #txtPhone class="form-control form-control-light bb" required="" data-label="Phone" data-msg="Vui lòng nhập Số điện thoại." type="text" name="phone" placeholder="* Số điện thoại" aria-required="true">
    
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input #txtEmail class="form-control form-control-light bb" data-label="Email" required="" data-msg="Vui lòng nhập Email." type="email" name="email" placeholder="* Email" aria-required="true">
                                                        </div>
                                                    </div>
                                                      <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input type="text"  
                                                            placeholder="Ngày sinh"
                                                            class="form-control form-control-light bb" #txtBirthday
                                                            bsDatepicker>
                                                            <!-- <input class="form-control form-control-light bb" data-label="DOB"  data-msg="Vui lòng nhập Ngày sinh." type="text" name="dob" placeholder="Ngày sinh"  > -->
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input #txtSponsor class="form-control form-control-light bb" data-label="ref"   data-msg="" type="text" name="ref" placeholder="Bạn biết chúng tôi từ đâu"  >
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <input #txtAddress class="form-control form-control-light bb" data-label="address"   data-msg="Địa chỉ thường trú" type="text" name="address" placeholder="Địa chỉ thường trú"  >
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <!-- (change)="changeArea(ddlFilterArea.value)"  -->
                                                            <!-- <input class="form-control form-control-light bb" data-label="area" required="" data-msg="Vui lòng chọn Khu vực" type="text" name="area" placeholder="* Khu vực đăng ký" aria-required="true"> -->
                                                            <select #ddlArea id="ddlFilterArea" class="form-control form-control-light bb" name="locationid" placeholder="* Khu vực đăng ký" aria-required="true">
                                                                <option value=""> -- * Khu vực đăng ký -- </option>
                                                                <ng-container *ngFor="let provine of provinces" >
                                                                  <!-- <ng-container *ngIf="group.lines !==null && group.lines !==undefined && group.lines?.length > 0" >
                                                                    <optgroup label="{{group.area}}">
                                                                   
                                                                      <ng-container *ngFor="let item of group.lines" >
                                                                        <option value="{{item.agentCode}}">  
                                                                          {{item?.province }}   
                                                                           <span *ngIf="(item?.province === null || item?.province === undefined || item?.province === '') && item?.area?.length > 0 ">
                                                                            {{item?.area }} 
                                                                          </span> 
                                                                         
                                                                          <span *ngIf="item?.address?.length > 0"> - {{item?.address}} 
                                          
                                          
                                                                          </span> </option>
                                          
                                                                      </ng-container>
                                                                     
                                                                    </optgroup>
                                                                  </ng-container> -->
                                                                 
                                                                  <!-- <option value="{{provine.codename}}">{{provine?.name}} </option> -->
                                                                 <ng-container *ngIf="provine.districts !==null && provine.districts !==undefined && provine.districts?.length > 0">
                                                                    <optgroup label="{{provine.name}}">
                                                                   
                                                                        <ng-container *ngFor="let dictrict of provine.districts" >
                                                                          <option value="{{dictrict.codename}}">  
                                                                                {{dictrict?.name }}   
                                                                             <!-- <span *ngIf="(item?.province === null || item?.province === undefined || item?.province === '') && item?.area?.length > 0 ">
                                                                                {{item?.area }} 
                                                                            </span>  -->
    <!--                                                                        
                                                                            <span *ngIf="item?.address?.length > 0"> - {{item?.address}} 
                                            
                                            
                                                                            </span> -->
                                                                         </option>
                                            
                                                                        </ng-container>
                                                                       
                                                                      </optgroup>
                                                                    
                                                                  </ng-container>
                                                                </ng-container>
                                                             </select>
    
                                                        </div>
                                                    </div>
                                                  </div>
                                                  
                                                 
                                                  <div class="form-group">
                                                        <h5 style="color: #C00C3F; font-style: italic; font-size: 13px;">* Chia sẻ với chúng tôi về những điều bạn đang quan tâm</h5>
                                                      <textarea #txtMessage  class="form-control form-control-light bb" data-label="Message" required="" data-msg="Tin nhắn" name="message" placeholder="Tin nhắn" cols="30" rows="5"  ></textarea>
                                                  </div>
                                              </div>
                                              <div class=" row" style="text-align: right">
                                                <button type="submit" class="btn solid btn-default txt-upper round mr-auto fs20" 
                                                (click)="register(txtName.value, txtCompany.value,  txtPhone.value, txtBirthday.value,  
                                                txtEmail.value, txtSponsor.value,  ddlArea.value, txtMessage.value)"
                                                ><i class="fa fa-envelope-o"></i> Đăng ký</button>
    
                                              </div>
                                          </form>
                                          
                                      </div>
                                  </div>
          
                              </div>
                          </div>
                      </div>
                  </section>
                  <!-- ************** END : CONTACT SECTION 01 **************  -->
    
                  <!--
                  ************************************************************
                  * FOOTER SECTION 01
                  *************************************************************
                  -->
                  <!-- data-rgradient="y" data-rg-colors="rgba(0, 0, 0, 0.5)|rgba(0, 0, 0, 1)" -->
                  <!-- <section id="socialsection" class="page-section swiper-slide typo-light" data-hash="social">
                      <div class="min-vh-h100 w100 flex-cc pd-tb-100" data-ckav-sm="pd-tb-large" 
                      >
                          <div class="innerwrapper w100 animated" data-animOut="fadeOut">
                              <div class="container">
                                  
          
                              </div>
                          </div>
                      </div>
                  </section> -->
                  <!-- ************** END : FOOTER SECTION 01 **************  -->
    
              </div>
              
              <!--=================================
              = PAGINATION
              ==================================-->
              <div class="scrollwrapper-pagination" data-ckav-sm="hide"></div>
              <!-- ======= END : PAGINATION =======  -->
    
          </div>